// extracted by mini-css-extract-plugin
module.exports = {"backgroundWrapper":"CarImageGallery_backgroundWrapper__sjcqp","backgroundImage":"CarImageGallery_backgroundImage__yEFEm","desktopCarImage":"CarImageGallery_desktopCarImage__xbd43"};